import { useQuery } from '@tanstack/react-query';

type DocumentType = 'MEETING_NOTE' | 'MEETING_AGENDA' | 'SUITABILITY_REPORT';

export type DocumentVersion = {
  id: string;
  documentHistoryId: string;
  documentType: DocumentType;
  versionNumber: number;
  fileId?: number;
  markdownContent?: string;
  markdownContentWithMarkers?: string;
  createdAt: string;
  isPrimary: boolean;
};

export function useDocumentVersions(documentId?: string) {
  const { data, isLoading, isError, refetch } = useQuery<DocumentVersion[]>({
    queryKey: ['documents', documentId, 'versions'],
    enabled: !!documentId,
    refetchOnWindowFocus: false,
  });

  return {
    versions: data ?? [],
    isLoading,
    isError,
    refetch,
  };
}
